import { render, staticRenderFns } from "./Lang.vue?vue&type=template&id=99a15afc&scoped=true"
import script from "./Lang.vue?vue&type=script&lang=js"
export * from "./Lang.vue?vue&type=script&lang=js"
import style0 from "./Lang.vue?vue&type=style&index=0&id=99a15afc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a15afc",
  null
  
)

export default component.exports